import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import StandardLanding from '../../../shared/components/StandardLanding';
import FormAddEditRecord from '../../general/FormAddEditRecord';
import { showCommunityAffair } from '../../general/action';
import { addCommunityAffair, editCommunityAffair } from '../action';

const Landing = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        if (id) {
            dispatch(showCommunityAffair(id, callback));
        }
    }, []);

    const callback = () => {

    };

    return (
        <StandardLanding>
            <div className="main-container content-crop">
                <div className="flex justify-between">
                    <p className="lg-title text-blue-10">RWP</p>
                    <p className="md-title text-gray-20">Add new report here</p>
                </div>
                <div className="mt-2">
                    <FormAddEditRecord
                        addCommunityAffair={addCommunityAffair}
                        editCommunityAffair={editCommunityAffair}
                    />
                </div>
            </div>
        </StandardLanding>
    );
};

export default Landing;
